import { Component, Input, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { AyrCommentsModel } from '../../../model/ayr-comments.model';
import { CommonModule } from '@angular/common';
import { HomeService } from '../../../services/home.service';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-reviews-slider',
    imports: [
        CommonModule,
        CarouselModule,
        TranslateModule
    ],
    templateUrl: './reviews-slider.component.html',
    styleUrl: './reviews-slider.component.scss'
})
export class ReviewsSliderComponent implements OnInit {
  @Input() commentItems: AyrCommentsModel[] | undefined;
  platformID = inject(PLATFORM_ID);
  customOptions: OwlOptions = {
    mouseDrag: true,
    touchDrag: false,
    pullDrag: true,
    dots: false,
    margin: 32,
    navSpeed: 700,
    navText: ['', ''],
    items: 1,
    nav: true,
    responsive: {
      500: {
        items: 1
      },
    },
  }
  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    if(!this.commentItems) {
      this.commentItems = this.homeService.commentsBuilder();
    }
  }

}
